import { SET_SELECTED_TENANT } from "redux/constants/User";

export const setSelectedTenant = (tenantSchema) => ({
	type: SET_SELECTED_TENANT,
	tenantSchema,
});
